<template>
    <div class="app has-header">
        <div class="header main">
            
            <div class="align-left">
                
            </div>
            <div class="align-middle">
               <headerbuttonstack :state="headerButtons"/>
            </div>
            <div class="align-right">
            </div>
        </div>
        <div class ="tablecontainer scrollbar-container">
            <h3 style="color: #6d8d23;">{{ $t('store.api.externalApiAccess') }}</h3>
            <datatable :state="dataTableState"/>
            
            <h3 v-if="isSuperUser" style="color: #6d8d23;">{{ $t('store.api.apiIntegration') }}</h3>
            <div v-if="isSuperUser">
                <datatable :state="apiIntegrationDataTableState"/>
            </div>
             
        </div>  
      
      
    <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
            </div>
        </div>
  </div>

</template>

<script>
import datatable from '../uicomponents/datatable.vue';
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'externalapiaccessoverview',
    components: {
        datatable,
    },
  data () {
    return {

        error: false,
        loading: true,
        loadingText: null,
    }
  },
  
    created: function () {
        if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
            this.refresh();
        }
    },
    computed: {
        ...mapGetters(['storeId', 'externalServicesMap', 'externalApiAccessMap', 'storeSettings', 'isSuperUser', 'uiDataMap', 'planningIndicatorTypeMap', 'apiIntegrationDataMap']),
        headerButtons(){

            let view = this;

            let state= {
                buttons: []
            };
            //BUTTON 1
            state.buttons.push({
                type: "block",
                icon: "fa-sync-alt",
                click: () => {
                    view.refresh(true); 
                },
                tooltip: this.$t('global.general.refreshData')
            });
            
            state.helperLinks = [
                    {
                        title:  this.$t('store.structure.getSupport'),
                        helperText:  this.$t('store.structure.getSupportHelp'),
                        externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/13",
                        externalLabel:  this.$t('store.structure.getSupportLabel'),
                        cancelLabel: this.$t('global.ui.close'),
                    }
                ];
            return state;
        },
        apiIntegrationTypeMap(){
            let map = {};
            Object.values(this.uiDataMap.apiIntegrationTypes).forEach(i => {
                map[i.id] = i;
            });
            return map;
        },
        externalServiceApiKeyMap() {
            let map = {};
            Object.values(this.externalApiAccessMap).forEach(i => {
                map[i.externalServiceId] = i.apiKey;
            });
            return map;
        },
        selectableExternalServices(){
            let items = [];
            const map = this.externalServiceApiKeyMap;
            Object.values(this.externalServicesMap).forEach(i => {
                if(!map[i.id]){
                    items.push({label: i.name, value: i.id});
                }
            });
            return items;
        },
        dataTableState(){
            let view = this;
            
            let state = {};
            
            let values = Object.values(this.externalApiAccessMap);
            
            state = this.$helpers.GetDataTableStateFromObject({externalServiceId: '', apiKey: '', enabled: true, locked: false},values);
            state.headerMap['externalServiceId'].sort = true;
            state.headerMap['externalServiceId'].label = "Service";
            state.headerMap['externalServiceId'].DisplayLabel = (i) => {return view.externalServicesMap[i.externalServiceId] ? view.externalServicesMap[i.externalServiceId].name : "-"};
        
           

            state.headerMap['apiKey'].sort = false;
            state.headerMap['apiKey'].label = "API Key";

            state.headerMap['enabled'].sort = false;
            state.headerMap['enabled'].label = this.$t('store.api.active');
            state.headerMap['enabled'].align = 'center';
            state.headerMap['enabled'].OnChange = (value, rowData, key) => {
                let item = {id: rowData.id, enabled: !rowData.enabled};
                view.editExternalApiAccess(item);
                  
            };

            state.headerMap['locked'].sort = false;
            state.headerMap['locked'].label = this.$t('store.api.fix');
            state.headerMap['locked'].align = 'center';
            state.headerMap['locked'].OnChange = (value, rowData, key) => {
                if(view.isSuperUser){
                    
                    view.editLockedExternalApiAccess(rowData.id, !rowData.locked);
                }  
            };
            
            state.headerMap['actions'] = {align: 'center',
                button: {icon: 'fas fa-plus', action: ($event, data) => view.OpenCreateExternalApiAccessModal($event)},
                buttons:[
                    {icon: 'fas fa-edit', action: ($event, data) => view.OpenEditExternalApiAccessModal($event, data)}, 
                    {icon: 'fas fa-trash', action: ($event, data) => view.OpenDeleteExternalApiAccessModal($event, data)},
                ]
            };
            
            state.headerMap['actions'].width = '100px';
            
            
            return state;
        },
        apiIntegrationDataTableState(){
            let view = this;
            
            let state = {};
            
            let values = Object.values(this.apiIntegrationDataMap);
            
            state = this.$helpers.GetDataTableStateFromObject({externalId: '', type: '', apiKey: '', disabled: false, plannedData: false, actualData: false},values);
            state.headerMap['type'].sort = true;
            state.headerMap['type'].label = this.$tc('global.general.type');
            state.headerMap['type'].DisplayLabel = (i) => {return view.apiIntegrationTypeMap[i.type] ? view.apiIntegrationTypeMap[i.type].label : "-"};
        
            state.headerMap['externalId'].sort = false;
            state.headerMap['externalId'].label = this.$t('store.api.externalId');
            state.headerMap['externalId'].DisplayLabel = (i) => {return i.externalId ? i.externalId: "-"};
        

            state.headerMap['apiKey'].sort = false;
            state.headerMap['apiKey'].label = "API Key";

            state.headerMap['disabled'].sort = false;
            state.headerMap['disabled'].label = this.$t('store.settings.deactivated');
            state.headerMap['disabled'].align = 'center';
            state.headerMap['disabled'].OnChange = (value, rowData, key) => {
                let item = Object.assign({}, rowData);
                item.disabled = !rowData.disabled;
                view.editApiIntegrationData(item);
                  
            };

            state.headerMap['plannedData'].sort = false;
            state.headerMap['plannedData'].label = this.$t('store.settings.planData');
            state.headerMap['plannedData'].align = 'center';
            state.headerMap['plannedData'].OnChange = (value, rowData, key) => {
                let item = Object.assign({}, rowData);
                item.plannedData = !rowData.plannedData;
                view.editApiIntegrationData(item);
                 
            };

            state.headerMap['actualData'].sort = false;
            state.headerMap['actualData'].label = this.$t('store.api.actualData');
            state.headerMap['actualData'].align = 'center';
            state.headerMap['actualData'].OnChange = (value, rowData, key) => {
                let item = Object.assign({}, rowData);
                item.actualData = !rowData.actualData;
                view.editApiIntegrationData(item);
                 
            };
            
            state.headerMap['actions'] = {align: 'center',
                button: {icon: 'fas fa-plus', action: ($event, data) => view.OpenEditApiIntegrationPopup(true)},
                buttons:[
                    {icon: 'fas fa-edit', action: ($event, data) => view.OpenEditApiIntegrationPopup(false, data)}, 
                    {icon: 'fas fa-trash', action: ($event, data) => view.OpenDeleteApiIntegrationDataModal($event, data)},
                ]
            };
            
            state.headerMap['actions'].width = '100px';
            
            
            return state;
        },
    },
    watch: { 
        storeId: function(val, oldVal) {
            this.refresh(true);
        },
    },
  // methods that implement data logic.
    methods: {
        refresh: function(force = false) {
            let view = this;
            this.loading = true;
            this.$helpers.GetExternalServicesMap()
            .then(map=>{
                return view.$helpers.GetExternalApiAccessMap(force);
            })
            .then(map=>{
                return view.$helpers.GetPlanningIndicatorTypeMap(force);
            })
            .then(map=>{
                return view.$helpers.GetApiIntegrationDataMap(force);
            })
            .then(map=>{
                view.loading = false;
            })
            .catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                view.loading = false;
                console.log(error)
            });
        },
        OpenCreateExternalApiAccessModal($event){
            let view = this;
            
            view.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        {label: 'Service', key: 'externalServiceId', disabled: false, hidden: false, type: 'dropdownsearch', value: null, flexGroup: false, 
                        dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: view.selectableExternalServices,
                            selectMultiple: false,
                            selectedItems: [],
                            selectedItem: null,
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: this.$t('store.settings.pleaseSelect'),
                        }}
                    ],
                    selectCallback: function (data) {
                        view.createExternalApiAccess(data);
                    }
                },
                header: this.$t('store.api.newApiAccess'),
                centered: true,
                expanded: true,
            });
        },
        createExternalApiAccess: function(item){
            let view = this;
            let url = '/api/sec/externalapiaccess';
            let params = {
                storeId: this.storeId,
            }


            let payload = {
                storeId: this.storeId,
                externalServiceId: item.externalServiceId,
                enabled: true,
            };

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                view.$store.commit("setExternalApiAccessMapEntry", response.data.data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.api.apiAccessAdded'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.api.addApiAccessError'));
                console.log(error)
            })

        },
        
        OpenDeleteExternalApiAccessModal($event, data){
            let view = this;
            view.$helpers.OpenAlert({header: this.$t('store.api.deleteApiAccess'), description: this.$t('store.api.deleteApiAccessQuery'), callbackAccept: (alert) => {
                alert.hidden = true;
                view.deleteExternalApiAccess(data);
            }});
        },
        deleteExternalApiAccess: function(item){
            let view = this;
            let url = '/api/sec/externalapiaccess';
            let params = {
                id: item.id,
                storeId: this.storeId,
            }
           

            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                params: params,
                url: url
            }).then(response => {
                view.$store.commit("deleteExternalApiAccessMapEntry", {id: item.id});
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.api.apiAccessDeleted'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.api.deleteApiAccessError'));
                console.log(error)
            })

        },
        OpenEditExternalApiAccessModal($event, item){
            let view = this;
           
            this.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        {label: 'Id', key: 'id', hidden: true, type: 'text', value: item.id},
                        {label: this.$t('store.api.active'), key: 'enabled', hidden: false, type: 'bool', value: item.enabled},
                       
                    ],
                    selectCallback: function (item) {
                        view.editExternalApiAccess(item);
                    },
                    
                },
                header: this.$t('store.api.editApiAccess'),
                centered: true,
                expanded: true,
            });
        },
        editExternalApiAccess: function(item){
            let view = this;
            let url = '/api/sec/externalapiaccess';
            let params = {
                
                storeId: this.storeId,
            }

            let payload = {
                id: item.id,
                enabled: item.enabled,
                updateFields: ["enabled"]
            };

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                let data = view.externalApiAccessMap[item.id]
                data.enabled = payload.enabled;
                

                view.$store.commit("setExternalApiAccessMapEntry", data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.api.accessEdited'));
            }).catch(function (error) {
               view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.accounting.updateApiError'));
               console.log(error)
            })

        },
        editLockedExternalApiAccess: function(id, locked){
            let view = this;
            let url = '/api/sec/externalapiaccess/locked';
            let params = {
                
                storeId: this.storeId,
                id: id, 
                locked: locked
            }

           

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                params: params,
            }).then(response => {
                let data = view.externalApiAccessMap[id]
                data.locked = locked;
                

                view.$store.commit("setExternalApiAccessMapEntry", data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.api.accessEdited'));
            }).catch(function (error) {
               view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.accounting.updateApiError'));
               console.log(error)
            })

        },
        OpenEditApiIntegrationPopup(create, apiIntegrationData = null){
        let view = this;
                
            let planningIndicatorItems = Object.values(this.planningIndicatorTypeMap).map(p => {return {label: p.name, value: p.id}});   
            let selectedTransactionItem = null;
            let selectedIncomeItem = null;
            let selectedNetIncomeItem = null;

            let typeItems = Object.values(this.apiIntegrationTypeMap).map(p => {return {label: p.label, value: p.id}});
            let selectedTypeItem = null;
            
            if(apiIntegrationData){
                selectedTransactionItem = planningIndicatorItems.find(p => p.value == apiIntegrationData.mdTransactionId);
                selectedIncomeItem = planningIndicatorItems.find(p => p.value == apiIntegrationData.mdIncomeId);
                selectedNetIncomeItem = planningIndicatorItems.find(p => p.value == apiIntegrationData.mdNetIncomeId);
                selectedTypeItem = typeItems.find(p => p.value == apiIntegrationData.type);
                
            }
            let dataEntries = [
                {label: 'Id', key: 'id', hidden: true, disabled: true, type: 'text', value: apiIntegrationData ? apiIntegrationData.id : null},
                
                {label: this.$t('store.api.externalId'), key: 'externalId', hidden: false, disabled: false, type: 'text', value: apiIntegrationData ? apiIntegrationData.externalId : null},
                {label: 'API Key', key: 'apiKey', hidden: false, disabled: false, type: 'text', value: apiIntegrationData ? apiIntegrationData.apiKey : null},
                {label: this.$tc('global.general.type'), key: 'type', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false,
                dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: typeItems,
                    selectMultiple: false,
                    selectedItems: selectedTypeItem ? [selectedTypeItem] : [],
                    selectedItem: selectedTypeItem ? selectedTypeItem : {},
                    onceSelected: function ($event, item, searchbar){
                            
                    },
                    styleLight: true,
                    placeholder: '',
                }},
                {label: this.$t('store.settings.tac'), key: 'mdTransactionId', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false,
                dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: planningIndicatorItems,
                    selectMultiple: false,
                    selectedItems: selectedTransactionItem ? [selectedTransactionItem] : [],
                    selectedItem: selectedTransactionItem ? selectedTransactionItem : {},
                    onceSelected: function ($event, item, searchbar){
                            
                    },
                    styleLight: true,
                    placeholder: '',
                }},
                {label: this.$t('store.settings.salesKeyFigure'), key: 'mdIncomeId', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false,
                dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: planningIndicatorItems,
                    selectMultiple: false,
                    selectedItems: selectedIncomeItem ? [selectedIncomeItem] : [],
                    selectedItem: selectedIncomeItem ? selectedIncomeItem : {},
                    onceSelected: function ($event, item, searchbar){
                            
                    },
                    styleLight: true,
                    placeholder: '',
                }},
                {label: this.$t('store.settings.netSalesKeyFigure'), key: 'mdNetIncomeId', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false,
                dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: planningIndicatorItems,
                    selectMultiple: false,
                    selectedItems: selectedNetIncomeItem ? [selectedNetIncomeItem] : [],
                    selectedItem: selectedNetIncomeItem ? selectedNetIncomeItem : {},
                    onceSelected: function ($event, item, searchbar){
                            
                    },
                    styleLight: true,
                    placeholder: '',
                }},
                
                
                {label: this.$t('store.settings.planData'), key: 'plannedData', hidden: false, disabled: false, type: 'bool', value: apiIntegrationData ? (apiIntegrationData.plannedData ?  apiIntegrationData.plannedData : false ): false},
                {label: this.$t('store.api.actualData'), key: 'actualData', hidden: false, disabled: false, type: 'bool', value: apiIntegrationData ? (apiIntegrationData.actualData ?  apiIntegrationData.actualData : false ): false},
                
                {label: this.$t('store.settings.deactivated'), key: 'disabled', hidden: !this.isSuperUser, disabled: !this.isSuperUser, type: 'bool', value: apiIntegrationData ? (apiIntegrationData.disabled ? apiIntegrationData.disabled : false ): false},
            ];

                
            this.$helpers.OpenPopup({
                elRelative: null,
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                        selectCallback: function (item) {
                            
                            let config = {
                                externalId: item.externalId,
                                type: item.type,
                                apiKey: item.apiKey,
                                mdTransactionId:  item.mdTransactionId,
                                mdIncomeId: item.mdIncomeId,
                                mdNetIncomeId: item.mdNetIncomeId,
                                plannedData: item.plannedData,
                                actualData: item.actualData,
                                disabled: item.disabled,
                                
                            }
                            if(create){
                                view.createApiIntegrationData(config);
                            } else {
                                config.id = item.id;
                                view.editApiIntegrationData(config);
                            }
                        },
                    },
                    header: this.$t('store.api.apiIntegrationData'),
                    remainAfterSelect: false,
                    expanded: true,
                    width: '700px',
                    centered: true
            });
        },
        createApiIntegrationData(data){
            let view = this;
            let url = '/api/sec/apiintegrationdata';
            let params = {
                storeId: this.$store.state.storeId
            }
            
            
            let payload = {
                apiKey: data.apiKey,
                externalId: data.externalId,
                type: data.type,
                mdIncomeId: data.mdIncomeId,
                mdNetIncomeId: data.mdNetIncomeId,
                mdTransactionId: data.mdTransactionId,
                disabled: data.disabled ? data.disabled : false,
                plannedData: data.plannedData ? data.plannedData : false,
                actualData: data.actualData ? data.actualData : false,  
                storeId: this.storeId, 
            };
            
            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload,
                params: params
            }).then(response => {
                view.$store.commit("setApiIntegrationDataMapEntry", response.data.data);
                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('store.api.apiIntegrationSaved'));
                

            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('store.api.saveApiIntegrationError'))
                console.log(error)
            })
        },
        editApiIntegrationData(data){
            let view = this;
            let url = '/api/sec/apiintegrationdata';
            let params = {
                storeId: this.$store.state.storeId
            }
            
            
            let payload = {
                id: data.id,
                updateFields: ["apiKey", "externalId", "type", "mdIncomeId", "mdNetIncomeId","mdTransactionId", 
                            "disabled", "plannedData", "actualData"],
                apiKey: data.apiKey,
                externalId: data.externalId,
                type: data.type,
                mdIncomeId: data.mdIncomeId,
                mdNetIncomeId: data.mdNetIncomeId,
                mdTransactionId: data.mdTransactionId,
                disabled: data.disabled ? data.disabled : false,
                plannedData: data.plannedData ? data.plannedData : false,
                actualData: data.actualData ? data.actualData : false,
                storeId: this.storeId, 
            };

            

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                view.$store.commit("setApiIntegrationDataMapEntry", data);
                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('store.api.apiIntegrationSaved'));
               
                
                
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('store.api.saveApiIntegrationError'))
                console.log(error)
            });
        },
        OpenDeleteApiIntegrationDataModal($event, data){
            let view = this;
            view.$helpers.OpenAlert({header: this.$t('store.api.deleteApiIntegration'), description: this.$t('store.api.deleteApiIntegrationQuery'), callbackAccept: (alert) => {
                alert.hidden = true;
                view.deleteApiIntegrationData(data);
            }});
        },
        deleteApiIntegrationData: function(item){
            let view = this;
            let url = '/api/sec/apiintegrationdata';
            let params = {
                id: item.id,
                storeId: this.storeId,
            }
           

            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                params: params,
                url: url
            }).then(response => {
                view.$store.commit("deleteApiIntegrationDataMapEntry", {id: item.id});
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.api.apiIntegrationDeleted'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.api.deleteApiIntegrationError'));
                console.log(error)
            })

        },
        
        
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .tablecontainer{
        padding-left: 30px;
        padding-right: 30px;
    }
 
    .has-header > .has-header > .scrollbar-container{
        height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
        top: var(--header-height);
    }
    .header.top{
        margin: 10px 0;
    }
    .data-table{
        top: 10px;
        position: relative;
    }

    .header.date{
        display: inline-flex;
        justify-items: center;
        align-items: center;
        position: absolute;
        left: 20px;
    }

    .header.date .label{
        color: var(--contrast-4);
        font-family: DistrictProLight;
        font-weight: 200;
        margin-top: -3px;
    }

    .header.date .label.bold{
        font-family: DistrictProBold;
        font-weight: 800;
        margin-right: 5px;
        margin-top: -3px;
    }

    .header.date .fa-calendar{
        margin: 0 10px;
        font-size: 20px;
        margin-top: -3px;
    }
    .header.date .fa-angle-left{
        margin: 0 10px;
        font-size: 25px;
        color: var(--contrast-4);
    }
    .indicator-view{
        padding: 30px;
        padding-bottom: 50px;
    }
</style>
